import { AssertTrue, ValidateEnumIsSubtype } from "@/domains/typing/types";
import type { PlatformIconKind } from "@/domains/api/types";
import { ApiSchema } from "@/modules/api";
import { UpsertedSyncUpdateResponse, DeletedSyncUpdateResponse } from "@/store/sync/types";

type ApiSpaceAccountAppCalloutModelData =
  ApiSchema["SpaceAccountAppCalloutSyncModelDataResponseSchema"] & {
    required_feature_flag?: string | null;
  };
type SpaceAccountAppCalloutIconKind = ApiSpaceAccountAppCalloutModelData["icon_kind"];

export type SpaceAccountAppCalloutModelData = Omit<
  ApiSpaceAccountAppCalloutModelData,
  | "icon_kind"
  | "primary_action_icon_kind"
  | "secondary_action_icon_kind"
  | "tertiary_action_icon_kind"
> & {
  icon_kind: SpaceAccountAppCalloutIconKind | PlatformIconKind.ArrowRight;
  primary_action_icon_kind: SpaceAccountAppCalloutIconKind | PlatformIconKind.ArrowRight;
  secondary_action_icon_kind: SpaceAccountAppCalloutIconKind | PlatformIconKind.ArrowRight;
  tertiary_action_icon_kind: SpaceAccountAppCalloutIconKind | PlatformIconKind.ArrowRight;
};

export type SpaceAccountAppCalloutUpsertedSyncUpdateValue = Omit<
  ApiSchema["SpaceAccountAppCalloutSyncModelResponseSchema"],
  "model_data"
> & {
  model_data: SpaceAccountAppCalloutModelData;
};
export type SpaceAccountAppCalloutDeletedSyncUpdateValue =
  ApiSchema["SyncUpdatePartialValueResponseSchema"];
export type SpaceAccountAppCalloutSyncUpdateValue =
  | SpaceAccountAppCalloutUpsertedSyncUpdateValue
  | SpaceAccountAppCalloutDeletedSyncUpdateValue;

export type SpaceAccountAppCalloutUpsertedSyncUpdate = UpsertedSyncUpdateResponse & {
  kind: "UPSERTED";
  value: SpaceAccountAppCalloutUpsertedSyncUpdateValue;
};
export type SpaceAccountAppCalloutDeletedSyncUpdate = DeletedSyncUpdateResponse & {
  kind: "DELETED";
  value: SpaceAccountAppCalloutDeletedSyncUpdateValue;
};
export type SpaceAccountAppCalloutSyncUpdate =
  | SpaceAccountAppCalloutUpsertedSyncUpdate
  | SpaceAccountAppCalloutDeletedSyncUpdate;

export type AppCalloutKindValues =
  ApiSchema["SpaceAccountAppCalloutSyncModelDataResponseSchema"]["callout_kind"];

export enum AppCalloutKind {
  BANNER = "BANNER",
  MODAL = "MODAL",
  CARD = "CARD",
  UNKNOWN = "UNKNOWN",
}

type _ValidateAppCalloutKindValues = AssertTrue<
  ValidateEnumIsSubtype<AppCalloutKind, AppCalloutKindValues>
>;
